/* Styles */
import "@/scss/main.scss";

/* Core */
import Vue from "vue";
import Buefy from "buefy";

/* Router & Store */
import router from "./router";
import store from "./store";

/* Service Worker */
import "./registerServiceWorker";

/* Vue. Main component */
import App from "./App.vue";

// Import the Auth0 configuration
import { domain, clientId, audience } from "../auth_config.json";

import { Auth0Plugin } from "./auth";

import * as VueGoogleMaps from "vue2-google-maps";

/* Default title tag */
const defaultDocumentTitle = "Prostock Trucking";

/* Collapse mobile aside menu on route change & set title */
router.afterEach(to => {
  store.commit("asideMobileStateToggle", false);
  store.commit("overlayToggle", false);
  store.commit("asideActiveForcedKeyToggle", null);

  if (to.meta && to.meta.title) {
    document.title = `${to.meta.title} — ${defaultDocumentTitle}`;
  } else {
    document.title = defaultDocumentTitle;
  }
});

Vue.config.productionTip = false;

Vue.use(Buefy);

// Install the authentication plugin here
Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  }
});

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAvPozVGRbHuxqcMyev1HBN-vDO1iMJzAE",
    libraries: "places"
    // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    // If you want to set the version, you can do so:
    // v: '3.26',
  },

  // If you intend to programmatically custom event listener code
  // (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  // instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  // you might need to turn this on.
  // autobindAllEvents: false,

  // If you want to manually install components, e.g.
  // import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  // Vue.component('GmapMarker', GmapMarker)
  // then set installComponents to 'false'.
  // If you want to automatically install all the components this property must be set to 'true':
  installComponents: true
});

Vue.config.errorHandler = function(err, vm, info) {
  console.log("Exception: ", err + " Vm: " + vm + " Info: " + info);
};

Vue.config.warningHandler = function(msg, vm, trace) {
  console.log("Warning: ", msg + " Vm: " + vm + " Trace: " + trace);
};

new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
    document.documentElement.classList.remove("has-spinner-active");
  }
}).$mount("#app");
